/**
 * Exam schemas — Spec Bölüm 7 + 12
 */
import { z } from 'zod';
import {
  CuidSchema,
  DifficultySchema,
  IndustrySchema,
  TopicSchema,
} from './common.js';

/** Spec 7.1 — Sınav oluştur (yönetici) */
export const CreateExamSchema = z
  .object({
    templateId: CuidSchema.optional(),
    customConfig: z
      .object({
        topicWeights: z.record(TopicSchema, z.number().min(0).max(1)),
        difficultyDistribution: z.record(DifficultySchema, z.number().min(0).max(1)),
        durationMin: z.number().int().min(15).max(240).default(90),
        questionCount: z.number().int().min(5).max(50).default(25),
      })
      .optional(),
    anonymousMode: z.boolean().default(false),
    /** Tekrar sınav — Delta raporları için (Spec 8.4) */
    previousExamId: CuidSchema.optional(),
  })
  .refine((d) => !!d.templateId || !!d.customConfig, {
    message: 'templateId veya customConfig zorunlu',
  });
export type CreateExamInput = z.infer<typeof CreateExamSchema>;

/** Spec 7.2 — Aday sınav giriş kodu doğrula */
// Prefix: firma adından türetilen 2-10 alfanumerik (örn. S2T6T — rakamlı isim olabilir)
// Suffix: 4 alfanumerik
export const ExamAccessSchema = z.object({
  accessCode: z
    .string()
    .regex(/^[A-Z0-9]{2,10}-[A-Z0-9]{4}$/, 'Geçersiz erişim kodu'),
});
export type ExamAccessInput = z.infer<typeof ExamAccessSchema>;

/** Aday yanıt — anlık auto-save (Spec 7.3.2) */
// selectedOption: MC için tek harf (A/B/C/D), DRAW_ERR için JSON-encoded
//   region kimliklerinin listesi veya koordinat dizisi (max 2KB).
export const SubmitAnswerSchema = z.object({
  questionId: z.string().min(1),
  selectedOption: z.string().min(1).max(2000).optional(),
  numericAnswer: z.number().optional(),
  timeSpentSec: z.number().int().min(0).max(7200),
});
export type SubmitAnswerInput = z.infer<typeof SubmitAnswerSchema>;

/** Spec 7.3.4 — Aday soru bayraklama */
export const FlagQuestionSchema = z.object({
  responseId: CuidSchema,
  note: z.string().max(500).optional(),
});
export type FlagQuestionInput = z.infer<typeof FlagQuestionSchema>;

/** Aday filter helpers */
export const ExamIndustryFilterSchema = z.object({
  industry: IndustrySchema.optional(),
});
